import { render } from "./ProductUpsale.vue?vue&type=template&id=5bf0576a&scoped=true"
import script from "./ProductUpsale.vue?vue&type=script&lang=js"
export * from "./ProductUpsale.vue?vue&type=script&lang=js"

import "./ProductUpsale.vue?vue&type=style&index=0&id=5bf0576a&scoped=true&lang=scss"

import exportComponent from "/srv/sites/eservice.talronbatt.co.il/api/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bf0576a"]])

export default __exports__